// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2G_ZP","loading":"List_loading__20tm8","pagination":"List_pagination__Ju2vS","page":"List_page__24q54","active":"List_active__27rhr"};